(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/shared/game-analysis-filter.js') >= 0) return;  svs.modules.push('/components/content/shared/game-analysis-filter.js');

'use strict';

var gameAnalysisFilterUtils = svs.isServer ? require(require('path').join(__dirname, 'game-analysis-filter-utils.es6')) : svs.content.shared.filters.gameAnalysisFilter.gameAnalysisFilterUtils;

var shouldRunGameAnalysisFilter = function shouldRunGameAnalysisFilter(resp) {
  var typeIsValid = gameAnalysisFilterUtils.typeIsValid;
  var shouldRun = false;
  if (resp.result) {
    resp.result.forEach(function (result) {
      if (typeIsValid(result)) {
        shouldRun = true;
      }
    });
  }
  return shouldRun;
};

var gameAnalysisFilter = function gameAnalysisFilter(resp) {
  var typeIsValid = gameAnalysisFilterUtils.typeIsValid,
    deepCopyOf = gameAnalysisFilterUtils.deepCopyOf,
    processAuthorProfileFrom = gameAnalysisFilterUtils.processAuthorProfileFrom,
    processGameAnalysis = gameAnalysisFilterUtils.processGameAnalysis,
    processGameAnalysesFrom = gameAnalysisFilterUtils.processGameAnalysesFrom,
    processDomainCategoriesFrom = gameAnalysisFilterUtils.processDomainCategoriesFrom,
    excludeVariableIn = gameAnalysisFilterUtils.excludeVariableIn,
    processRenamingOn = gameAnalysisFilterUtils.processRenamingOn,
    excludedRootVariables = gameAnalysisFilterUtils.excludedRootVariables;
  if (resp && resp.result) {
    var rawResults = resp.result;
    var processedResults = [];
    rawResults.forEach(function (result) {
      if (typeIsValid(result)) {
        var copyOfResult = deepCopyOf(result);
        if (copyOfResult.authorProfile) {
          copyOfResult.authorProfile = processAuthorProfileFrom(deepCopyOf(result.authorProfile));
        }
        var isSingleGameAnalysis = copyOfResult.contentType === 'cnt:gameAnalysis';
        if (isSingleGameAnalysis) {
          copyOfResult = processGameAnalysis(copyOfResult);
        } else if (copyOfResult.gameAnalyses) {
          copyOfResult.gameAnalyses = processGameAnalysesFrom(deepCopyOf(result.gameAnalyses));
        }
        if (copyOfResult.domainCategories) {
          copyOfResult.domainCategories = processDomainCategoriesFrom(deepCopyOf(result.domainCategories));
        }
        if (copyOfResult.properties) {
          var cntGameSystems = copyOfResult.properties.cnt_gameSystems;
          if (Array.isArray(cntGameSystems) && cntGameSystems.length) {
            copyOfResult.gameSystems = copyOfResult.properties.cnt_gameSystems;
            copyOfResult.firstGameSystem = copyOfResult.properties.cnt_gameSystems[0];
          }
        }
        excludedRootVariables.forEach(function (excludedVariable) {
          copyOfResult = excludeVariableIn(copyOfResult, excludedVariable);
        });
        copyOfResult = processRenamingOn(copyOfResult);
        processedResults.push(copyOfResult);
      }
    });
    resp.result = processedResults;
  }
  return resp;
};

var gameAnalysisFilterLegacy = function gameAnalysisFilterLegacy(resp) {
  if (resp && resp.result) {
    var validTypes = gameAnalysisFilterUtils.validTypes;
    var results = resp.result;
    results.forEach(function (result, index) {
      if (validTypes.indexOf(result.contentType) > -1) {
        results[index] = JSON.parse(JSON.stringify(result).split('domainCategories').join('gameinfo'), function (key, value) {
          if (key === 'gameinfo') {
            var gameinfo = {};
            value.forEach(function (item) {
              var itemValue = item.split('/')[1];
              var itemKeyName = item.split('svs-domain-')[1].split('/')[0];
              if (!gameinfo[itemKeyName]) {
                gameinfo[itemKeyName] = [];
              }
              itemValue = Number.isNaN(Number(itemValue)) ? itemValue : Number(itemValue);
              gameinfo[itemKeyName].push(itemValue);
            });
            return gameinfo;
          } else if (['parentId', 'parentName', 'rank', 'version'].indexOf(key) > -1) {
            return undefined;
          }
          return value;
        });
      }
    });
    resp.result = results;
  }
  return resp;
};
var exportPayload = {
  gameAnalysisFilter: gameAnalysisFilter,
  gameAnalysisFilterLegacy: gameAnalysisFilterLegacy,
  shouldRunGameAnalysisFilter: shouldRunGameAnalysisFilter
};
if (svs.isServer) {
  module.exports = exportPayload;
} else {
  svs.content.shared.filters.gameAnalysisFilter = exportPayload;
}

 })(window);